/* eslint semi:0 */
import BaseClass from 'application/BaseClass'
import { makeSafeFn, } from 'utils/fn'
import { getElementById, } from 'utils/dom'
import namespace, { NAMESPACE, } from 'application/nm'
import { getCountryCode } from 'providers/geolocationProvider'
import { external as externalScriptLoader, } from 'utils/script'
import brightcovePlayerActions from 'actions/brightcovePlayerActions'


const BRIGHTCOVE_API_MODULE_NAMES = {
  VIDEO_PLAYER: 'VIDEO_PLAYER',
  ADVERTISING: 'ADVERTISING',
}

class BaseBrightcovePlayer extends BaseClass {

  constructor(playerId){
    super()
    this.merge({ playerId, })
  }

  // private
  get player(){ return this._player || (this._player = this.generatePlayer()) }

  generatePlayer(){ throw new Error('Must implement method in subclass') }

}

class FlashBrightcovePlayer extends BaseBrightcovePlayer {

  // public
  setVolume(volume){
    if (this.player.fapiSetVolume) {
      this.player.fapiSetVolume(volume)
    }
  }
  // private
  generatePlayer(){ return getElementById(this.playerId) }

}

let safeGetBrightcoveApiModule = makeSafeFn(moduleName => window.brightcove.api.modules.APIModules[moduleName])
let safeGetBrightcoveExperience = makeSafeFn(playerId => window.brightcove.api.getExperience(playerId))

class SmartBrightcovePlayer extends BaseBrightcovePlayer {

  // public
  play(){ return this.player.play() }

  pause(){ return this.player.pause(true) }

  getCurrentVideo(callback){ return this.player.getCurrentVideo(callback) }

  // private
  getAPIModuleByName(moduleName){
    return this.experience.getModule(safeGetBrightcoveApiModule(moduleName))
  }
  generatePlayer(){ return this.getAPIModuleByName(BRIGHTCOVE_API_MODULE_NAMES.VIDEO_PLAYER) }

  get experience(){ return safeGetBrightcoveExperience(this.playerId) }

}

export default class CompoundBrightcovePlayer extends BaseClass {

  constructor(playerId){
    super({ playerId, })
    this.merge({
      playerId,
      flashPlayer: FlashBrightcovePlayer.create(playerId),
      smartPlayer: SmartBrightcovePlayer.create(playerId),
    })
  }

  // public
  setVolume(volume){ return this.flashPlayer.setVolume(volume) }

  play(){ return this.smartPlayer.play() }

  pause(){ return this.smartPlayer.pause() }

  getCurrentVideo(callback){ return this.smartPlayer.getCurrentVideo(callback) }

  get adModule(){
    return this.smartPlayer.getAPIModuleByName(BRIGHTCOVE_API_MODULE_NAMES.ADVERTISING)
  }

  getAdModulePolicy(adPolicyHandler){
    // TODO: convert to promise
    return this.adModule.getAdPolicy(adPolicyHandler)
  }

  setAdModulePolicy(adPolicy, adPolicySetHandler){
    // I have no idea why, but directly passing the function as the
    // second argument to setAdPolicy didn't work. *shrug*
    this.adModule.setAdPolicy(adPolicy, () => adPolicySetHandler(adPolicy))
    return this
  }

  addCompoundEventListener(eventType, callback) {
    this.smartPlayer.player.addEventListener(eventType, callback)
    this.flashPlayer.player.addEventListener(eventType, callback)
  }

}

class GlobalHandler extends BaseClass {

  constructor(handlerName){
    super()
    this.handlerName = handlerName
    this.createGlobalName()
  }

  createGlobalName(){
    namespace.brightcoveGlobalHandlers = namespace.brightcoveGlobalHandlers || {}
    namespace.brightcoveGlobalHandlers[this.handlerName] = this
  }

  registerPlayer(playerId){
    this[playerId] = brightcovePlayerActions[this.handlerName].part(CompoundBrightcovePlayer.create(playerId))
  }

  globalInvocationName(playerId){
    this.registerPlayer(playerId)
    return `${ NAMESPACE }.brightcoveGlobalHandlers.${ this.handlerName }.${ playerId }`
  }

}

function onExternalLoaded(){
  return getCountryCode()
    .then(brightcovePlayerActions.externalLoaded)
    .catch(brightcovePlayerActions.externalLoaded);
}

let brightcovePlayerProvider = {

  handlers: {
    templateReady: GlobalHandler.create('templateReady'),
  },

  load(){
    externalScriptLoader.load({ name: 'brightcove', })(onExternalLoaded)
  },

}

export { brightcovePlayerProvider, }


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/brightcove/brightcovePlayerProvider.js